import React, { useState } from "react";
import { QRFlowLeftNavBar } from "../ReusableComp/NavBarLeft";
import NavigationBar from "../ReusableComp/NavigationBar";
import { Col, Container, Row, Stack, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import CryptoJS from 'crypto-js';
import {
  getSubjectDtls,
  getEventDetails,
  getReviewerComments,
  getAllWhoddClassification,
  getSubjProfDetails,
  getPmsNotifications,
  getAllWhoddClassificationNew
} from "../../Redux/actions/actions";
import PopUpModal from "../ReusableComp/PopUpModal";
import {
  EVENT_STATUS_WAITING_FOR_REVIEW,
  EVENT_STATUS_IN_PROGRESS,
  EVENT_STATUS_REVIEWED,
  EVENT_STATUS_SENT_BACK_FOR_REVIEW,
  base_url,
  SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT,
  SUBJECT_STATUS_ON_STUDY,
  SUBJECT_STATUS_OFF_STUDY,
  EVENT_CLASSIFICATION_AESI,
  EVENT_CLASSIFICATION_LEVEL_BRIGHTON,
  EVENT_CLASSIFICATION_GRADE_CTCAE,
  EVENT_CLASSIFICATION_OTHER,
  QUALITY_REVIEWER,
  MEDICAL_REVIEWER,
  PRINCIPAL_INVESTIGATOR,
  SUBJECT_REVIEW_STATUS_REVIEWED,
  CRYPTO_SECRET_KEY,
  WHODD_CONCOMITANT_MEDICATION,
  WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS
} from "../../utilities";
import axios from "../../axios-interceptor";
import moment from "moment";
import { PopUpAlert } from "../ReusableComp/PopUpModal";
import Loader from '../ReusableComp/Loader';
import { formatDateNoTime } from "../ReusableComp/dateFormat";
import { useNavigate, useLocation } from "react-router";
import { Modal, Button } from 'react-bootstrap';
import { Tooltip } from "react-tooltip";
import { ThreeDots } from "react-loader-spinner";
import { WhoDDConcomAndWhodd } from "./QrSubjectReview";
import PasswordModal from "./PasswordModal";
 


const QRSubjectsList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const qrSubjectList = useSelector((state) => state.qrSubjectList);
  const subjDetails = useSelector((state) => state.subjDtls);
  const subjectCounts = useSelector((state) => state.qrSubjectcounts);
  const reviewerComments = useSelector((state) => state.reviewerComments);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredData, setFilteredData] = useState(null);
  const [searchText, setSearchText] = useState("");
  let [loading_flag, setloading_flag] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const eventDtls = useSelector((state) => state.eventDtls);
  const [flag, setFlag] = useState(false);
  const [asc, setAsC] = useState(false);
  const [desc, setDesc] = useState(false);
  const subjectProfile = useSelector((state) => state.getSubProf);
  let extensions = ""
  const location = useLocation();
  const getEventFlag = useSelector((state) => state.getEventFlag);
  const [selectedOption, setSelectedOption] = useState(getEventFlag?.option);  
  const handleRadioChange = (selectedValue) => {
    setSelectedOption(selectedValue);
    if (selectedValue === 'serious_adverse_events') {
      setFilteredData(qrSubjectList.filter(i => i.serious_adverse_event_id !== null))
    } else if (selectedValue === 'adverse_events') {
      setFilteredData(qrSubjectList.filter(i => i.adverse_event_id !== null))
    } else if(selectedValue === 'subject_with_pending'){
      setFilteredData(qrSubjectList.filter(i => i.status === 0 || i.status===1))
    }else if (selectedValue === 'all_events') {
      setFilteredData(qrSubjectList)
    }
  };


  useEffect(() => {
    setloading_flag(true)
    if(qrSubjectList){
      if (selectedOption === 'serious_adverse_events') {
        setFilteredData(qrSubjectList.filter(i => i.serious_adverse_event_id !== null))
      } else if (selectedOption === 'adverse_events') {
        setFilteredData(qrSubjectList.filter(i => i.adverse_event_id !== null))
      } else if(selectedOption === 'subject_with_pending'){
        setFilteredData(qrSubjectList.filter(i => i.status === 0 || i.status===1))
      }else if (selectedOption === 'all_events' || selectedOption === "total_reviews") {
        setSelectedOption("all_events")
        setFilteredData(qrSubjectList)
      }
      else{
        setSelectedOption("all_events")
        setFilteredData(qrSubjectList)
      }
      }
    if (location.state !== null && qrSubjectList !== null) {
      handleSubjectData(location.state?.data);
      // setCurrentPage(2);
      navigate({ state: null });
    }
    // setloading_flag(true);
    if(open1){
      setloading_flag(false)
    }
    if (qrSubjectList) {
      setFilteredData(qrSubjectList)
      setTimeout(() => {
        setloading_flag(false)
      }, 600);
    }

  }, [dispatch, localStorage.pi_id,localStorage.study_id, qrSubjectList !== null]);

  useEffect(()=>{
    if(qrSubjectList){
      setFilteredData(qrSubjectList);
    }
  },[qrSubjectList])

  useEffect(() => {
    if (eventDtls?.action_taken_for_adverse_event_name !== "None") {
      setFlag(true);
    }
    else {
      setFlag(false)
    }
    setTimeout(() => {
      setloading_flag(false);
    }, 200);

    if(currentPage===2 && eventDtls){
      setLoading(false)
    }

  }, [eventDtls,currentPage])

  const medraList = useSelector((state) => (state.medraList));


  const whoddList = useSelector((state) => (state.whoddList));


  const JustBtwn = "d-flex justify-content-between";

  const aeSubject = useSelector((state) => state.getAeOfSubj);
  const [qrStudyId, setQrStudyId] = useState("");
  const [whoDDClassification, setWhoDDClassification] = useState();
  const [meddraClassification, setMeddraClassification] = useState();
  const [loading, setLoading] = useState(false);

   function getStudieId(id) {
    setQrStudyId(id);
  }
  const handleDeleteMeddra=()=>{
    setMeddraClassification()
  }

  const dateOfReport = aeSubject?.date_of_report;
  const lastDayActiveFollowUp = aeSubject?.last_day_active_follow_up;
  const stepperData = [];
  const date = new Date(dateOfReport);
  while (date <= new Date(lastDayActiveFollowUp)) {
    stepperData.push({
      day: `Day${stepperData.length + 1}`,
      dateOfevent: date.toISOString().split("T")[0],
    });
    date.setDate(date.getDate() + 1);
  }
  function exportToExcel() {

    let excelArray = [];
    filteredData.forEach((i) => {

      switch (i.status) {
        case EVENT_STATUS_WAITING_FOR_REVIEW:
          i.status = "Waiting for review";
          break;
        case EVENT_STATUS_IN_PROGRESS:
          i.status = "In progress";
          break;
        case EVENT_STATUS_REVIEWED:
          i.status = "Reviewed";
          break;
        case EVENT_STATUS_SENT_BACK_FOR_REVIEW:
          i.status = "Sent back for review";
          break;
        default:
          break;
      }

      let xl_object = {
        "Date of upload": moment(i.event_createdAt).format("DD-MMM-YYYY"),
        "Adverse Events": i.adverse_event_name,
        "Serious Adverse Criteria": i.serious_adverse_event_name,
        "Subject ID": i.subject_code,
        "Site Name": i.site_name,
        "Status": i.status,
      };
      excelArray.push(xl_object);
    });
    // create the data that you want to write to the excel file
    const data = excelArray;

    // create a worksheet and add the data to it
    const worksheet = XLSX.utils.json_to_sheet(data);

    // create a workbook and add the worksheet to it
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // create the excel file and save it to the user's device
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const fileName = "QR_event reviewlist.xlsx";
    const file = new Blob(
      [XLSX.write(workbook, { bookType: "xlsx", type: "array" })],
      { type: fileType }
    );
    FileSaver.saveAs(file, fileName);
  }

  const [open, setOpen] = React.useState(false);
  const [open2,setOpen2] = React.useState(false)

  const dashboardCards = [
    {
      count: subjectCounts?.saesCount,
      image: "./images/icons/exclamatory.svg",
      desc: "Serious Advesre Events",
      bgcolor: "#D14141",
      id:"serious_adverse_events"
    },
    {
      count: subjectCounts?.aesCount,
      image: "./images/icons/smiley.svg",
      desc: "Adverse Events",
      bgcolor: "#EA9E4F",
      id:"adverse_events"
    },
    {
      count: subjectCounts?.pendingReviews,
      image: "./images/icons/pending approval.svg",
      desc: "Pending",
      bgcolor: "#EAEAEA",
      textColor: "#000000",
      id : "subject_with_pending"
    },
    {
      count: subjectCounts?.subjectsCount,
      image: "./images/icons/subjects_white.svg",
      desc: "Total Subjects",
      bgcolor: "#8DA2B5",
      textColor: "white",
      id : "all_events"
    },
  ];
  let status = subjDetails && `${subjDetails['SubjectDoses.status']}`
  const myArray = [
    {
      title: subjDetails && subjDetails['Study.study_name'],
      description: "Study",
    },
    {
      description: "Dose",
      title: subjDetails && `D${subjDetails['SubjectDoses.dose']}`,
    },
    {
      title: subjDetails && subjDetails['PrincipalInvestigator.name'],
      description: "Principal Investigator",
    },
    {
      id: 4, description: "Status", title:
        status == SUBJECT_STATUS_ON_GOING_ADVERSE_EVENT ? 'On going adverse event' :
          status == SUBJECT_STATUS_ON_STUDY ? 'On study' :
           status == SUBJECT_STATUS_OFF_STUDY ? 'Concluded study' : ''
    }
  ];
  

  const handleStudyChange = () => {
    setFilteredData(null);
    setSearchText("");
  };



  const handleSearchData = (event) => {
    const searchText = event.target.value?.toLowerCase();
    setSearchText(searchText);
    const filteredData = qrSubjectList?.filter((item) => {
      const { subject_code, site_name } = item;

      const formattedSubjectCode = subject_code?.toLowerCase();
      const formattedSiteName = site_name ? site_name.toLowerCase() : ""


      return (
        formattedSubjectCode.includes(searchText) ||
        formattedSiteName.includes(searchText)
      );
    });

    setFilteredData(filteredData);
  };


  const [subjData, setSubjData] = useState([]);
  const [studyDropdwn, setStudyDropdwn] = useState(false);
  const [studyOption, setStudyOption] = useState();
  const [inputValue, setInputValue] = useState('');

  const [reviewedDtls, setReviewedDtls] = useState(false);

  const handleSubjectData = (data) => {
    
    setLoading(true)
    if (inputValue) {
      setCurrentPage(2);
    }
    if (data.status === EVENT_STATUS_REVIEWED ) {
      setReviewedDtls(true);
    }
    if (data.status === EVENT_STATUS_IN_PROGRESS ) {
      setReviewedDtls(false);
    }
   
    if((qrSubjectList?.find(item => (item.subject_id === data.subject_id) && (item.adverse_event_id === data.adverse_event_id)).status) === EVENT_STATUS_SENT_BACK_FOR_REVIEW){
      // window.location.reload()
      setOpen1(true)
      setloading_flag(false)
      // window.location.reload()
      // alert("The event has already been attended to!")
      // return;
    }

    setSubjData(data)
    dispatch(getSubjectDtls(data))
    dispatch(getEventDetails(data))
    dispatch(getAllWhoddClassification())
    dispatch(getSubjProfDetails({subject_id: data.subject_id,
      dose:data.dose}))
    dispatch(getReviewerComments({
      adverse_event_mapping_id: data?.adverse_event_id
    }))
    if(!open1){
      if (data.status === EVENT_STATUS_WAITING_FOR_REVIEW) {
        let each_marketing_head = {
          event_id: data.adverse_event_id,
          event_type: parseInt(data.event_type)
        };
        axios
          .post(
            base_url + "quality-reviewer/update_event_status",
            each_marketing_head
          )
          .then((res) => {
             
            setStudyDropdwn(true);
            setCurrentPage(2);
           setLoading(false)
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        setStudyDropdwn(true);
        setCurrentPage(2);
      }
    }
    
   
  };

 
  const [medraSelected, setIsMedraSelected] = useState(false)

  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

  
  useEffect(() => {

  }, [eventDtls?.adverse_event_mapping_id, qrStudyId])

  const [whoddBlock, setWhoddBlock] = useState({
    "atccode": "",
    "productcode": ""
  })

 

  function handleWHODD(e) {
    const { name, value } = e.target;

    setWhoddBlock((prev => ({
      ...prev,
      [name]: value,
    })))
  }

  const [reviewerComment, setReviewerComment] = useState('')
  const handleReviewerComments = (e) => {
    let val = e.target.value;
    let value = val.trim()
    setReviewerComment(value || '')
  };
  const cmtbtnStat = reviewerComment !== ''

  function sentBack() {
    setLoading(true)
    if (eventDtls) {
      axios
        .post(base_url + "comments/add_comment", {
          "adverse_event_mapping_id": eventDtls?.adverse_event_mapping_id,
          "reviewer_id": localStorage.qr_id,
          "user_persona": QUALITY_REVIEWER,
          "comment": reviewerComment,
          "created_by": localStorage.login_user_name
        })
        .then((res) => {
          setLoading(false)
          setPwdModalShow(false)
          window.location.reload();
        })
    }
  }
  const [alertMessage, setAlrtMessage] = useState('')
  const [btnId, setBtnId] = useState('')
  const [pwdModalShow, setPwdModalShow] =useState(false)
  const [enteredPassword, setEnteredPassword] = useState("")
  const handleClose = () => {
    setPwdError(false)
    setEnteredPassword('')
    setPwdModalShow(false)
    if (pwdModalShow == false) {
        setEnteredPassword('')
    }
  };
  const [pwdError, setPwdError] = useState(false)
  
  const handlePwdChange = (e) => {
    setEnteredPassword(e.target.value);
    
      };


      const handleConfirmPwd = () => {
        const bytes = CryptoJS.AES.decrypt(localStorage.getItem("pwdid"), CRYPTO_SECRET_KEY);
        const originalText = bytes.toString(CryptoJS.enc.Utf8);
        if (originalText === enteredPassword) {
          setPwdError(false)
    
          if (btnId === "closereview") {
            handlecloseReveiw()
          } else if (btnId === "sendBack") {
            sentBack()
          }
        } else {
          setPwdError(true)
        }
    
      }

  function handleReviewActions() {
    if (btnId === 'cancel') {
      setOpen(false)
    } else if (btnId === "sendBack") {
      setOpen(false)
      setPwdModalShow(true)
    } else if (btnId === 'closereview') {
      setOpen(false)
      setPwdModalShow(true)
      
    }
  }

  function handleClosePopup() {
    setOpen(false)
    setOpen1(false)
    setOpen2(false)
  }
  const [masterArray, setMasterArray] = useState([])
  const [masterArray2, setMasterArray2] = useState([])
  const [existingWhoddIds,setExistingWhoddIds] = useState([])

  let finalIds = masterArray?.map(i => i.whodd_id);
  
  let uniqueIds = [...new Set(finalIds),...new Set(existingWhoddIds)];
   
  finalIds = Array.from(uniqueIds);
  let filteredIds = finalIds.filter(i => i)
  let commentObj = {
    "adverse_event_mapping_id": eventDtls?.adverse_event_mapping_id,
    "meddra_llt_master_id": (!meddraClassification)? null : (masterArray2[0]?.meddra_llt_master_id || eventDtls?.meddraObject?.meddra_llt_master_id),
    "meddra_mdhier_master_id": (!meddraClassification)? null : (masterArray2[0]?.meddra_mdhier_master_id || eventDtls?.meddraObject?.meddra_mdhier_master_id),
    "whodd_ids": filteredIds,
    "created_by": localStorage.login_user_name,
    "reviewer_id": localStorage.qr_id,
    "user_persona": QUALITY_REVIEWER,
    "comment": reviewerComment,
  }

  function handlecloseReveiw() {

    if (eventDtls) {
      axios
      .post(base_url + "quality-reviewer/finish_review", commentObj)
      .then((res) => {
        setLoading(false)
          setPwdModalShow(false)
          setOpen2(true)
          
        })
    }
  }
  const getQrData = useSelector((state) => state.qrStudyList);
  function handleReviewBtns(e) {
    let id = e.target.id;
    setBtnId(id)
    dispatch(getPmsNotifications({
      user_id: localStorage.login_user_id,
      user_persona: QUALITY_REVIEWER,
      study_id: getQrData?.map(item => item.study_id)
    }))
    if (id === 'sendBack') {
      setAlrtMessage("Are you sure you want to send back for correction?")
      setOpen(true)
    } else if (id === 'closereview') {
      setAlrtMessage("Are you sure you want to close the review?")
      setOpen(true)
    } 
    else {
      // setFilteredData(qrSubjectList)
      setCurrentPage(1)
      setReviewedDtls(false)
      let updatedData = [...medicationDetails]
      updatedData?.map((i) => {
        i.searchTerm =''
      })
      setMedicationDetails(updatedData)
      
      // dispatch(resetEventDetails())
      // dispatch(resetSubjectProfile())
      window.location.reload()
    }
  }



  const [value, setValue] = useState("");
  const [value1, setValue1] = useState("");
  const [encodeMeddrabtn, setEncodeMeddrabtn] = useState(true);

  const [suggestionsWhodd, setSuggestionsWhodd] = useState([])
  const [dotsFlag1, setDotsFlag1] = useState(false)
  const [listFlag1, setListFlag1] = useState(false)

  const handleWhoDDClassification = (event, index) => {
    setEncodeBtn(false)
    setListFlag1(false)
    setDotsFlag1(false)
    setNoRecordsFlag1(false)
    const inputValue = event.target.value;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      if (inputValue.length > 2) {
        setEncodeBtn(true)
        setListFlag1(true)
        setDotsFlag1(true)
        fetchSuggestionsWhodd(inputValue);
      } else {
        setSuggestionsWhodd([]);
        setEncodeBtn(false)
        setListFlag1(false)
        setDotsFlag1(false)
        setNoRecordsFlag1(false)
      }
    }, 300);
    if(event.target.value.length >= 3){
      getAllWhoddClassificationNew(event.target.value)
    }
    medicationDetails.map((data) => {
      if (data.current_idx == index) {
        if (event.target.value == "") {
          data.whoDDEncode = true
          let fData = masterArray?.filter(i => i.index !== index)
          setMasterArray(fData)

          setIsBtn(false)
          data.whoddArray = []
          data.searchTerm = ''
          setMedicationDetails(medicationDetails)
          setEncodeBtn(true)

        } else {
          data.whoDDEncode = false
          setValue1(event.target.value);
          data.searchTerm = event.target.value
          setMedicationDetails(medicationDetails)
        }

      }
    })

  };


  const onSearch = (sTerm, index) => {
    setListFlag(false)
    setValue(sTerm);
    meddraDetails.map((data, index1) => {
      if (data.current_idx == index) {
        data.searchTerm = sTerm
        data.medDRAEncode=true
        setMeddraDetails(meddraDetails)
        setEncodeMeddrabtn(false)
      }
    })
  };

  const handleAscending = () => {
    setAsC(true);
    setDesc(false);

    const sortedData = [...filteredData];

    sortedData.sort((a, b) => {
      const subjectCodeA = a.subject_code;
      const subjectCodeB = b.subject_code;

      return subjectCodeA.localeCompare(subjectCodeB);
    });

    setFilteredData(sortedData);
  };

  const handleDescending = () => {
    setDesc(true);
    setAsC(false);

    const sortedData = [...filteredData];

    sortedData.sort((a, b) => {
      const subjectCodeA = a.subject_code;
      const subjectCodeB = b.subject_code;
      return subjectCodeB.localeCompare(subjectCodeA);
    });


    setFilteredData(sortedData);
  };



  const [encodeBtn, setEncodeBtn] = useState(true)

  const onSearch1 = (searchTerm, index) => {
    setValue1(searchTerm);
    setListFlag1(false)
    setDotsFlag1(true)
    setEncodeBtn(false)
    setSuggestionsWhodd([])
    let updatedData = [...masterArray]
    updatedData?.map((ele,i)=>{
    if(ele.index==index){
      updatedData.splice(i,1)
    }
  })
  setMasterArray(updatedData)
    medicationDetails.map((data, index1) => {
      // data.whoDDEncode = true;
      if (data.current_idx == index) {
        data.whoDDEncode = false
        data.whoddArray=[]
        data.searchTerm = searchTerm
        setMedicationDetails(medicationDetails)
      }
    })
    setSuggestionsWhodd([])
    };

  const handleDeleteFieldsWhoDD = (index) => {
    setIsBtn(true)
    let updatedData = [...medicationDetails]
    updatedData?.map((elemObj, i) => {
      if (elemObj.current_idx == index) {
        updatedData.splice(i, 1)
      }
    })
    setMedicationDetails(updatedData)

    masterArray?.map((ele, i) => {
      if (ele.index == index) {
        masterArray.splice(i, 1)
      }
    })
    setMasterArray(masterArray)
  }
 
  useEffect(() => {
    if (eventDtls) {
      setInputValue(eventDtls.meddraObject?.llt_name)
      setValue(eventDtls.meddraObject?.llt_name);
      setMasterArray(eventDtls?.whoddDrugs)
      setExistingWhoddIds(eventDtls?.whoddDrugs?.map(i => i[0]?.whodd_id))

      // setSelectedMedraId(eventDtls.meddraObject?.meddra_classification_master_id)
      setIsMedraSelected(true)

      
      eventDtls.whoddDrugs?.map(item =>
        setSelectedCheckboxes((prevSelectedCheckboxes) => [...prevSelectedCheckboxes, item.whodd_id])
      )
      setWhoDDClassification(eventDtls.whoddDrugs)
      setMeddraClassification(eventDtls?.meddraObject)
    }
    
    if (eventDtls) {
      whoddList?.map((item, i) => {
        if (item.whodd_classification_master_id === eventDtls.whodd_classification_master_id) {
          setValue1(item.generic_name);
          
        }
      });
    }



  }, [eventDtls?.adverse_event_mapping_id, eventDtls])
  const [meddraDetails, setMeddraDetails] = useState([
    {
      "searchTerm": "",
      "current_idx": 0,
      "checkedMeddra":"",
      "medDRAEncode": false,
      "meddraArray": [],
    },
  ]);
 

  const [listFlag, setListFlag] = useState(false)
  
  const [dotsFlag, setDotsFlag] = useState(false)
  const [suggestions, setSuggestions] = useState([]);
  let debounceTimer;
  

  const handleMeddraClassification1 = (event, index) => {
    setListFlag(true)
    setDotsFlag(true)
    setNoRecordsFlag(false)
    const inputValue = event.target.value;
  
    clearTimeout(debounceTimer); 
    debounceTimer = setTimeout(() => {
      if (inputValue.length > 0) {
        fetchSuggestions(inputValue);
      } else {
        setSuggestions([]);
      }
    }, 300); 
    meddraDetails.map(data => {
      if (data.current_idx == index) {
        if (event.target.value == "") {
            setListFlag(false)
          data.meddraArray = []
          setValue("")
          data.searchTerm = ''
          setNoRecordsFlag(false)
          setDotsFlag(false)
          setEncodeMeddrabtn(true)
          data.medDRAEncode =false
          data.checkedMeddra=''
        } else {
          setValue(event.target.value);
          data.searchTerm = event.target.value
          setEncodeMeddrabtn(true)
        }
      }
    })
    setMeddraDetails(meddraDetails)
  };
  const[noRecordsFlag, setNoRecordsFlag] = useState(false)
  const fetchSuggestions = async (searchQuery) => {
    axios
    .post(base_url + "meddra-master/fetch_all_llt_names_based_on_search_term",{"llt_name":searchQuery})
    .then((response) => {
    setSuggestions(response.data.data)
    setDotsFlag(false)
    if(response.data.data.length===0){
      
      setNoRecordsFlag(true)
    }
    else{
      setNoRecordsFlag(false)
      setListFlag(false)
      setDotsFlag(false)
    }
  })
}
  const [noRecordsFlag1 ,setNoRecordsFlag1] = useState(false)

  const fetchSuggestionsWhodd = async (searchQuery) => {
    axios
    .post(base_url + "whodd/fetch_drug_names_based_on_search_term",{"search_term":searchQuery})
    .then((response) => {
      const finalArray = response.data.data.productNames.filter(name => !masterArray?.map(item => item.whoddName).includes(name));
      setSuggestionsWhodd(finalArray)
      setDotsFlag1(false)
    if(response.data.data.length===0 && searchQuery.length>2){
      setNoRecordsFlag1(true)
    }
    else{
      setNoRecordsFlag1(false)
    }
    })
  }


   
  const [isBtn, setIsBtn] = useState(false)
  const [medView, setMedView] = useState(true)
  const [array, setArray] = useState([])
  const [loadFlag1, setLoadFlag1] = useState(false)
  const onEncode1 = (searchTerm, object) => {
   
    setValue1(searchTerm);
    setListFlag1(false)
    setDotsFlag1(true)
    setLoadFlag1(true)
    axios
      .post(
        base_url + "whodd/fetch_complete_drug_details", {
        "drug_name": searchTerm
      }
      )
      .then((res) => {
        let whoddArray = res.data.data
        setLoadFlag1(false)
          setArray(whoddArray)
          medicationDetails.map((data, index) => {
            if (data.searchTerm != "" || data.searchTerm !== null) {
              setIsBtn(false)
            }
            else {
              setIsBtn(true)
            }
            if (data.current_idx == object.current_idx) {
              data.whoDDEncode = true
              medicationDetails[index].whoddArray = whoddArray;
              setMedicationDetails(medicationDetails)
              if (whoddArray?.length === 1) {

                setMasterArray((prev) => ([...prev, {
                  whodd_id: whoddArray[0].whodd_id,
                  index: object.current_idx,
                  whoddName: whoddArray[0].drug_name

                }]))

              } else {

                setMasterArray((prev) => ([...(prev || []), {
                  whodd_id: null,
                  index: object.current_idx,
                  whoddName: null

                }]))
              }
            }
          })
      })
  }


  const [loadFlag, setLoadFlag] = useState(false)
  const onEncode2 = (searchTerm, object) => {
    setLoadFlag(true)
    setMedView(false)
    setValue(searchTerm);
    setListFlag(false)
    axios
      .post(
        base_url + "meddra-master/fetch_llt_occurences", {
        "llt_name": searchTerm
      }
      )
      .then((res) => {
        let meddraArray = res.data.data
        setLoadFlag(false)
    meddraDetails.map((data, index) => {
      if (data.searchTerm != "" || null) {
        setIsBtn(true)
      }
      else {
        setIsBtn(false)
      }
      if (data.current_idx == object.current_idx) {
        data.medDRAEncode =true;
        meddraDetails[index].meddraArray = meddraArray;
        setMeddraDetails(meddraDetails)
        if (meddraArray?.length === 1) {

          setMasterArray2((prev) => ([...prev, {
            meddra_llt_master_id: meddraArray[0]?.meddra_llt_master_id,
            index: object.current_idx,
            meddra_mdhier_master_id: meddraArray[0]?.meddra_mdhier_master_id,

          }]))

        } else {

          setMasterArray2((prev) => ([...prev, {
            meddra_llt_master_id: null,
            index: object.current_idx,
            meddra_mdhier_master_id: null

          }]))
        }



      }
    })

  })


  }
  
 
  const [medicationDetails, setMedicationDetails] = useState([
    {
      "searchTerm": "",
      "whoDD_type": "",
      "medication_id":"",
      "current_idx": 0,
      "whoDDEncode": false,
      "whoddArray": []
    },
  ]);
  const [whoddClassificationMasterId, setWhoddClassificationMasterId] = useState('')

  const handleCheckboxChange = (event, checkboxId, index) => {
    
    setIsBtn(true)
    masterArray.map(i => {
      if (i.index == index) {
        i.whodd_id = checkboxId.whodd_id;
        i.whoddName = checkboxId.drug_name
      }
    })
    setMasterArray(masterArray)

    setWhoddClassificationMasterId(checkboxId.whodd_id)
    if (event.target.checked) {

      if (array?.length > 1) {
        setSelectedCheckboxes((prev) =>
          !prev.includes(checkboxId.whodd_id) ?
            [...prev, checkboxId.whodd_id] : prev
        )
      }
    } else {
      setSelectedCheckboxes((prevSelectedCheckboxes) =>
        prevSelectedCheckboxes.filter((id) => id !== checkboxId.whodd_id)
      );
    }
  };

  const handleDelete = (event) => {
    let updatedData = [...whoDDClassification]

    updatedData?.map((elemObj, i) => {
      if (elemObj.whodd_id === event) {
        updatedData.splice(i, 1)
      }
    })
    setWhoDDClassification(updatedData)


    setSelectedCheckboxes((prevSelectedCheckboxes) =>
      prevSelectedCheckboxes.filter((id) => id !== event)
    );
    setMasterArray((prevSelectedCheckboxes) =>
      prevSelectedCheckboxes.filter((id) => id.whodd_id !== event)
    );

  };

  const handleCheckboxChange2 = (selectedCheckbox, index) => {
   let updatedData = [...meddraDetails]
   updatedData.map(i => {
     if(i.current_idx === index){
       i.checkedMeddra = selectedCheckbox.meddra_mdhier_master_id
     }
   })
   masterArray2.map(i => {
     if(i.index === index){
       i.meddra_llt_master_id = selectedCheckbox.meddra_llt_master_id
       i.meddra_mdhier_master_id = selectedCheckbox.meddra_mdhier_master_id
     }
   })
   setMeddraDetails(updatedData)
   // setIsBtn(true)
 };


  function calculateBMI(weight, height) {
    if (isNaN(weight) || isNaN(height) || height === null) {
      return "0"; // Display "N/A" if either weight or height is not a number
    }
    const bmi = weight / ((height / 100) ** 2);

    return bmi.toFixed(1);
  }

  const [currentIndex, setCurrentIndex] = useState(1);

  function calculateBMI(weight, height) {
    if (isNaN(weight) || isNaN(height) || height === null) {
      return "0"; // Display "N/A" if either weight or height is not a number
    }
    const bmi = weight / ((height / 100) ** 2);

    return bmi.toFixed(1);
  }

  const handleAddFields = () => {
    setIsBtn(false)
    setMedicationDetails([...medicationDetails,
    {
      "ATC": "",
      "searchTerm": "",
      "Product": "",
      "whoDDEncode": false,
      "current_idx": currentIndex + 1
    },]);
    setValue1("")
    setCurrentIndex(currentIndex + 1);
  };

  const cleanText =
    eventDtls?.study_case_definition === EVENT_CLASSIFICATION_AESI ? eventDtls?.input_notes_aesi_others :
      eventDtls?.study_case_definition === EVENT_CLASSIFICATION_LEVEL_BRIGHTON ? eventDtls.study_event_meets_case_definition || eventDtls.study_event_doesnt_meets_case_definition :
        eventDtls?.study_case_definition === EVENT_CLASSIFICATION_GRADE_CTCAE ? eventDtls.study_ctcae_definition :
          eventDtls?.study_case_definition === EVENT_CLASSIFICATION_OTHER ? eventDtls?.input_notes_aesi_others : '';
  const disableFields = subjDetails?.review_status !== SUBJECT_REVIEW_STATUS_REVIEWED

  function getIcon(fileExtension) {
    switch (fileExtension) {
      case 'pdf':
        return "./images/icons/reshot-icon-pdf.svg"
      case 'ppt':
        return "./images/icons/reshot-icon-ppt.svg"
      case 'txt':
        return "./images/icons/reshot-icon-txt.svg"
      case 'docx':
        return "./images/icons/reshot-icon-docx.svg"
      case 'doc':
        return "./images/icons/reshot-icon-doc.svg"
      case 'xls':
        return "./images/icons/reshot-icon-xls.svg"
      case 'csv':
        return "./images/icons/reshot-icon-csv.svg"
      case 'jpg':
        return "./images/icons/reshot-icon-jpg.svg"
      case 'png':
        return "./images/icons/reshot-icon-png.svg"
      case 'jpeg':
        return "./images/icons/reshot-icon-jpeg.svg"
    }
  }
 
  const handleCloseModal = () => {
    setSelectedDocument(null);
  };
  const isImage = (url) => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
    return imageExtensions.includes(url);

  };
  const [open1, setOpen1] = useState(false)

  const alreadyAttended = ()=>{
    setOpen1(false)
    window.location.reload()
      return;
  }

  const alreadyAttended2 = ()=>{
    setOpen2(false)
    window.location.reload()
      return;
  }
  return (
    <>
      <div>
      <PasswordModal pwdError={pwdError} handleConfirmPwd={handleConfirmPwd} handlePwdChange={handlePwdChange} enteredPassword={enteredPassword} pwdModalShow={pwdModalShow} handleClose={handleClose}/>
        <NavigationBar
          studyDropdwn={studyDropdwn}
          title={"Event Review List"}
          handleFilteredData={handleStudyChange}
          getStudieId={getStudieId}
        />
        <PopUpModal
        handleClose={handleClosePopup}
        open={open2}
        title={"Success!"}
        msg={"Event review has been closed!"}
        close={"Close"}
        actionbtn={"Done"}
        onConfirm={alreadyAttended2}
        
        />
        {/* <QRFlowLeftNavBar /> */}
        <div className="main_body ">
        <PopUpModal
        handleClose={handleClosePopup}
        open={open1}
        title={"Success!"}
        msg={"Event has already been attended to!"}
        close={"Close"}
        actionbtn={"Done"}
        onConfirm={alreadyAttended}
        
        />
          {currentPage === 1 && (
            <Container fluid className="py-4 ">
              <Stack className="add_subject_stack px-0">
                <div className="">
                  <Row className="d-flex">
                    {dashboardCards?.map((card, index) => {
                      return (
                        <Col key={index}>
                          <div
                            className="card-container C-pointer"
                            onClick={() => handleRadioChange(card.id)}
                            style={{ backgroundColor: card.bgcolor , outline: selectedOption === card.id ? "2px solid black" :"" }}
                          >
                            <div
                              className="content"
                              style={{ color: card.textColor }}
                            >
                              <span>{card.count}</span>
                              <img src={card.image} alt="" />
                            </div>
                            <div
                              className="desc"
                              style={{ color: card.textColor }}
                            >
                              {card.desc}
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              </Stack>

              {qrSubjectList && qrSubjectList?.length > 0 ? (
                <Container fluid className="pitable_container mt-2  ">
                  <Row className='searchbar'>
                    <Col className='searchFiled gap-3'>
                      <label htmlFor="" />
                      <input type="text" value={searchText} style={{ width: "400px" }} placeholder='Search with Subject ID or Site Name' onChange={handleSearchData} />
                      <div className=" ">
                        <button
                          className="btn btn-success "
                          onClick={exportToExcel}
                          style={{ height: "42px" }}
                        >
                          <span className='fa-download-icon'><i className="fa-solid fa-download" /></span>
                          <span className='dwld_txt'>Download XLS</span>
                          <img src="./images/icons/download.svg" alt="#" style={{ marginLeft: "5px" }} />
                        </button>
                      </div>

                    </Col>
                  </Row>

                  <div>
                    {loading_flag ? (
                      <div className=''>
                        <img
                          className="atrium_loader"
                          src="/images/circle-effect-loading.gif"
                          alt="Loader"

                        />
                      </div>

                    ) : (
                      <div className="table-scroll-container " style={{ border: "1px solid #E1E5E7 " }}>
                        {filteredData?.length > 0 ?
                          <Table bordered size="sm" className="pitable mb-0">
                            <thead className="sticky_table_header">
                              <tr>
                                <th> S.No</th>
                                <th className="sticky-header">
                                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <span style={{ fontSize: 14, fontWeight: 600, marginTop: 0, paddingLeft: "40%" }}>Subject ID</span>
                                    <svg width="30" height="30" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ float: "right" }}>
                                      <g id="icon_sort">
                                        <path id="icon" d="M13.3471 21.1433C13.1481 21.4277 12.7269 21.4277 12.5279 21.1433L8.23821 15.0152C8.00624 14.6839 8.24332 14.2285 8.64783 14.2285H17.2272C17.6317 14.2285 17.8688 14.6839 17.6368 15.0152L13.3471 21.1433Z" fill={desc ? "black" : "#E1E5E7"} onClick={handleDescending} className='svg-cursor' />
                                        <path id="icon_2" d="M13.3471 4.31368C13.1481 4.02932 12.7269 4.02932 12.5279 4.31368L8.23821 10.4418C8.00624 10.7732 8.24332 11.2285 8.64783 11.2285H17.2272C17.6317 11.2285 17.8688 10.7732 17.6368 10.4418L13.3471 4.31368Z" fill={asc ? "black" : "#E1E5E7"} onClick={handleAscending} className='svg-cursor' />
                                      </g>
                                    </svg>
                                  </div>
                                </th>
                                <th style={{ minWidth: "145px" }}>
                                  Adverse Events
                                </th>
                                <th>
                                  Serious Adverse Criteria
                                </th>
                                <th>
                                  Date of upload
                                </th>

                                <th style={{ minWidth: "70px" }}>
                                  Site Name
                                </th>
                                <th>Status</th>
                              </tr>
                            </thead>

                            <tbody className="tableBodyScroll">
                              {filteredData?.map((i, index) => {
                                let formatedDate = formatDateNoTime(i.event_createdAt)
                                return (
                                  <tr key={index} className="text_left_table">
                                    <td className="text_right_sno"> {index + 1} </td>
                                    <td>{i.subject_code ? i.subject_code :"-"}</td>
                                    <td>{i.adverse_event_name ? i.adverse_event_name :"-"}</td>
                                    <td>{i.serious_adverse_event_name ? i.serious_adverse_event_name :"-"}</td>
                                    <td className="text-center">{formatedDate}</td>
                                    {/* <td>{i.site_name}</td> */}
                                    <td><span title={i.site_name}>{i.site_name ? i.site_name :"-"}</span></td>

                                    <td className="viewbtnstyles">
                                      {i.status ===
                                        EVENT_STATUS_WAITING_FOR_REVIEW && (
                                          <button
                                            className="gray_btn py-1"
                                            onClick={() => handleSubjectData(i)}
                                          >
                                            Waiting for review
                                          </button>
                                        )}
                                      {i.status === EVENT_STATUS_IN_PROGRESS && (
                                        <button
                                          className="orange_btn py-1"
                                          onClick={() => handleSubjectData(i)}
                                        >
                                          In progress
                                        </button>
                                      )}
                                      {i.status === EVENT_STATUS_REVIEWED && (
                                        <button
                                          className="green_btn py-1"
                                          onClick={() => handleSubjectData(i)}
                                        >
                                          Reviewed
                                        </button>
                                      )}
                                      {i.status ===
                                        EVENT_STATUS_SENT_BACK_FOR_REVIEW && (
                                          <button
                                            className="red_btn py-1"
                                            disabled
                                            // onClick={() => handleSubjectData(i)}
                                          >
                                            Sent Back For Review
                                          </button>
                                        )}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                          :
                          <div className="bg-white border py-4 text-center">No records found with search criteria</div>

                        }
                      </div>
                    )}
                  </div>


                </Container>
              ) : qrSubjectList === null && localStorage.study_id ? <div className=''>
                    <img
                        className="atrium_loader"
                        src="/images/circle-effect-loading.gif"
                        alt="Loader"

                    />
                  </div> :   (
                <>


                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: '5rem' }}>
                    <img src="./images/no_subjects.svg" alt="Telephone" />
                    <h5> No events found</h5>
                  </div>
                </>
              )}
            </Container>
          )}

          {currentPage === 2 && subjDetails && eventDtls && subjectProfile && (
            <Container fluid className="page_two_styl px-0 pt-1">
              <Row className="SVdtl_Main">
                <Col lg={4} className="section_1">


                  {subjDetails && <div className="pisubj_left_main">
                    <div className="review_min_high">
                      <div className="body_cls pb-2">


                        <span>

                          <h6 className="mb-3">{subjDetails?.subject_code}</h6>

                          <div className="row">
                          <div className="col-6 p-0">
                            <div className="mb-0">
                              <span className="mb-1" style={{padding:"0px"}}>Age:</span> <span className="space_yrs highlet-left">{subjDetails?.age} Yrs</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="mb-0">
                              <span className="mb-1">Height:</span> <span className='space_height highlet-left'>{subjDetails?.height ? subjDetails.height : 0} cm</span>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6 p-0">
                            <div className="mb-0">
                              <span className="mb-1">Gender:</span> <span className='highlet-left'>{subjDetails?.sex}</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="mb-0">
                              <span className="mb-1">Weight:</span> <span className='highlet-left'>{subjDetails?.weight}Kg</span>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 p-0">
                            <div className="mb-1">
                              <span className="mb-0">BMI:</span> <span className="space_bmi highlet-left">{calculateBMI(subjDetails?.weight, subjDetails?.height)} (BMI)</span>
                            </div>
                          </div>
                          </div>
                        </span>
                     
                        

                        <span className="d-flex justify-content-between w-100">

                          <h6 className="site_add">
                            {subjDetails['Site.site_address']}
                          </h6>
                          <img
                            className=""
                            src="./images/icons/location.svg"
                            alt="Location Icon"
                          />
                        </span>
                      </div>
                      <div className="px-3 s2">
                        {myArray.map((i, index) => {
                          return (
                            <div className="studytab" key={index}>
                              <span className="text-start">{i.title}</span>
                              <span className="study_tab_desc">
                                {i.description}
                              </span>
                            </div>
                          );
                        })}
                      </div>

                      <div className="px-3 s2">
                        {reviewerComments && reviewerComments?.filter(i => i.user_persona === QUALITY_REVIEWER).length > 0 &&
                          <div className="studytab">
                            <span className="text-start">
                              Quality Reviewer Comments
                            </span>
                            {reviewerComments && reviewerComments?.filter(
                              i => i.user_persona === QUALITY_REVIEWER
                            ).map((i, index) => {
                              return (
                                <div key={index}>

                                  <div className="qr_cmts_txt d-flex flex-row">
                                    <li></li>
                                    <div>{i.comment}</div>
                                  </div>
                                  <span className="qr_cmts_date ">
                                    By : {i.created_by} {", "} On :{" "}
                                    {moment(i.createdAt).format("DD/MM/YYYY HH:mm:ss")}
                                  </span>
                                </div>

                              );
                            })
                            }
                          </div>}



                        {reviewerComments && reviewerComments?.filter(i => i.user_persona === MEDICAL_REVIEWER).length > 0 &&
                          <div className="studytab">

                            <span className="text-start">
                              Medical Reviewer Comments
                            </span>
                            {reviewerComments && reviewerComments?.filter(
                              i => i.user_persona === MEDICAL_REVIEWER
                            ).map((i, index) => {
                              return (
                                <div key={index}>

                                  <div className="qr_cmts_txt d-flex flex-row">
                                    <li></li>
                                    <div>{i.comment}</div>
                                  </div>
                                  <span className="qr_cmts_date ">
                                    By : {i.created_by} {", "} On :{" "}
                                    {moment(i.createdAt).format("DD/MM/YYYY HH:mm:ss")}
                                  </span>
                                </div>

                              );
                            })

                            }
                          </div>
                        }
                      </div>


                    </div>
                  </div>}
                </Col>
                <div className="col review_event_header pisub">
                  <div className='title_cls right_cntnt'>
                    <h5 className="mb-1">Event {
                      disableFields ? <span style={{ marginLeft: "5px", color: "red", fontSize: "18px" }}>(Note :The subject to this event has not been reviewed. Please review the subject before reviewing this event.)
                        &nbsp; <button className="btn btn-primary" onClick={() => navigate('/qrsubjectreview')}>Click to navigate</button>
                      </span> : ""
                    }</h5>
                  </div>

                  <Col className="px-4 py-3 qr_right_content">
                    <div className="d-flex justify-content-between ">

                      <div className="">
                        <label htmlFor="dateOfonSet" className="custm_label_fw">
                          Date of onset
                        </label>
                        <input
                          value={eventDtls?.date_of_onset}
                          className="customInput"
                          id="dateOfonSet"
                          type="date"
                          placeholder="Enter Here"
                          disabled
                          aria-placeholder="#D4D4D4"
                          style={{
                            padding: "16px 12px",
                            width: "340px",
                            cursor: "not-allowed",
                          }}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                      </div>

                      <div className="">
                        <label htmlFor="timeOfonSet" className="custm_label_fw">
                          Time of onset (24 Hrs)
                        </label>
                        <input
                          value={eventDtls?.time_of_onset}
                          className="customInput"
                          disabled
                          id="timeOfonSet"
                          type="time"
                          placeholder="Enter Here"
                          aria-placeholder="#D4D4D4"
                          style={{ padding: "16px 12px", width: "340px" }}
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-between ">
                      <div className="">
                        <label
                          htmlFor="dateOfResolution"
                          className="custm_label_fw"
                        >
                          Date of resolution
                        </label>
                        <input
                          value={eventDtls?.date_of_resolution}
                          // value={moment(eventDtls?.date_of_resolution).format("DD-MM-YYYY")}
                          disabled
                          className="customInput"
                          id="dateOfResolution"
                          // min={minDate}
                          type="date"
                          placeholder="Enter Here"
                          aria-placeholder="#D4D4D4"
                          style={{
                            padding: "16px 12px",
                            width: "340px",
                            cursor: "not-allowed",
                          }}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                      </div>

                      <div className="">
                        <label htmlFor="lastName" className="custm_label_fw">
                          Time of resolution (24 Hrs)
                        </label>
                        <input
                          value={eventDtls?.time_of_resolution}
                          disabled
                          className="customInput"
                          id="lastName"
                          type="time"
                          placeholder="Enter Here"
                          aria-placeholder="#D4D4D4"
                          style={{ padding: "16px 12px", width: "340px" }}
                        />
                      </div>
                    </div>

                    <div htmlFor="lastName" className="custm_label_fw">
                      Past Health History
                    </div>
                    <div className="d-flex justify-content-between">
                      <div>
                        <label htmlFor="lastName" className="">
                          Allergies
                        </label>
                        <input
                          value={eventDtls?.allergies ? eventDtls.allergies : '-'}
                          disabled
                          className="customInput"
                          id="lastName"
                          type="text"
                          aria-placeholder="#D4D4D4"
                          style={{ padding: "16px 12px", width: "340px" }}
                        />
                      </div>
                      <div>
                        <label htmlFor="medical_history" className="">
                          Medical history
                        </label>
                        <input
                          value={eventDtls?.medical_history ? eventDtls.medical_history : '-'}
                          disabled
                          className="customInput"
                          id="medical_history"
                          type="text"
                          aria-placeholder="#D4D4D4"
                          style={{ padding: "16px 12px", width: "340px" }}
                        />
                      </div>
                    </div>

                    <div className="d-flex justify-content-between">
                      <div>
                        <label htmlFor="lastName" className="">
                          Concurrent Illness
                        </label>
                        <input
                          value={eventDtls?.concurrent_illness ? eventDtls.concurrent_illness : '-'}
                          disabled
                          className="customInput"
                          id="lastName"
                          type="text"
                          aria-placeholder="#D4D4D4"
                          style={{ padding: "16px 12px", width: "340px" }}
                        />
                      </div>
                     
                    </div>

                    {eventDtls?.serious_adverse_event_name &&
                      <Row className="d-flex align-items-center">

                        <Col>
                          <label htmlFor="lastName" className="custm_label_fw">
                            Serious adverse event criteria
                          </label>
                        </Col>
                        <Col>
                          <span>
                            <button className="red_btn advesre-serious" > {eventDtls?.serious_adverse_event_name}</button>
                          </span>
                        </Col>
                      </Row>
                    }
                    {eventDtls?.study_aebank_event_title !== null && <Row className="d-flex align-items-center">
                      <Col>
                        <label htmlFor="lastName" className="custm_label_fw">
                          Adverse event
                        </label>
                      </Col>
                      <Col>
                        <span>
                          <button className="orange_btn advesre-serious" > {eventDtls?.study_aebank_event_title}</button>
                        </span>
                      </Col>
                    </Row>}
                    <div className="advEventGroup">
                      <div className="p-4 bg-light rounded eventClassificationDiv">
                        <div className="custm-radio-styl reviewlist">
                          <div className="reviewaetilte">
                            <label
                              htmlFor="notmetcase"
                              style={{
                                display: "flex",
                                alignItems: "start",

                              }}
                            >
                              <input
                                type="radio"
                                id="notmetcase"
                                checked
                                style={{ width: "20px" }}
                              />
                              <span
                                style={{ marginLeft: "10px" }}
                              >
                                <div className="custm-radio-styl ">
                                  {eventDtls?.study_event_meets_case_definition !== null ?
                                    "Event meet case definition" :
                                    eventDtls?.study_event_doesnt_meets_case_definition !== null ?
                                      "Event does not meet case definition" :
                                      eventDtls?.study_ctcae_definition !== null ?
                                        "Grade" :
                                        eventDtls?.study_aebank_event_title && eventDtls?.study_case_definition == EVENT_CLASSIFICATION_AESI ? 'Adverse Event of Special Interest' : 'Other'
                                  }
                                </div>
                              </span>
                            </label>
                          </div>

                          <div className="subtext">
                            <img src="./images/icons/checkedbox.svg" alt="" />
                            <span>{cleanText}</span>
                          </div>
                        </div>
                      </div>
                    </div>



                    <div className={` gap-2 border p-3 rounded`}>
                      <div className="d-flex flex-column gap-3">
                        <div className={`d-flex ${JustBtwn}`}>
                          <div className="">
                            <label htmlFor="causality">
                              Causality
                            </label>
                            <input
                              value={eventDtls?.causality_name}
                              disabled
                              className="customInput"
                              id="lastName"
                              type="text"
                              placeholder="Enter Here"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}
                            />
                          </div>
                          <div className="">
                            <label htmlFor="outCome">
                              Outcome
                            </label>
                            <input
                              value={eventDtls?.outcome_name}
                              disabled
                              className="customInput"
                              id="lastName"
                              type="text"
                              placeholder="Enter Here"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}
                            />
                          </div>

                        </div>
                        <div className={`d-flex ${JustBtwn}`}>
                          <div className="">
                            <label htmlFor="actionTaken">
                              Action Taken For Study Vaccine
                            </label>
                            <input
                              value={eventDtls?.action_taken_name}
                              disabled
                              className="customInput"
                              id="lastName"
                              type="text"
                              placeholder="Enter Here"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}
                            />
                          </div>
                          <div className="">
                            <label htmlFor="actionTaken">
                              Action Taken For Adverse Event
                            </label>
                            <input
                              value={eventDtls?.action_taken_for_adverse_event_name}
                              disabled
                              className="customInput"
                              id="lastName"
                              type="text"
                              placeholder="Enter Here"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}
                            />

                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between ">
                        {flag && (
                          <div className="start-end-date">
                            <label htmlFor="startDate" className="custm_label_fw">
                              <p className="adverse-auto">Treatment Start Date</p>
                            </label>
                            <input
                              value={eventDtls?.start_date_of_treatment}
                              className="custminputbml selectTag"
                              id="start_date_of_treatment"
                              type="date"
                              disabled
                              placeholder="Enter Start Date"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}

                            />
                          </div>
                        )}
                        {/* End Date input */}
                        {flag && (
                          <div className="start-end-date">
                            <label htmlFor="endDate" className="custm_label_fw">
                              <p className="adverse-auto">Treatment End Date</p>
                            </label>
                            <input
                              value={eventDtls?.end_date_of_treatment}
                              className="custminputbml selectTag"
                              id="end_date_of_treatment"
                              type="date"
                              disabled
                              placeholder="Enter End Date"
                              aria-placeholder="#D4D4D4"
                              style={{ padding: "16px 12px", width: "340px" }}

                            />
                          </div>
                        )}
                      </div>
                    </div>


                    {reviewerComments && reviewerComments?.filter(i => i.user_persona === PRINCIPAL_INVESTIGATOR).length > 0 &&
                      <div>
                        <label htmlFor="Treatment" className="fw-bold fs-6">Treatment Given</label>
                        <div
                          className="border py-3 px-2 rounded w-100"

                        >
                          {
                            reviewerComments && reviewerComments?.map((i, index) => {
                              return (
                                i.user_persona === PRINCIPAL_INVESTIGATOR ?
                                  <div className="d-flexflex-column" key={index}>
                                    <div className="d-flex">
                                      <li></li>
                                      <div>{i.comment.charAt(0).toUpperCase() + i.comment.slice(1)}</div>
                                    </div>
                                    <p className=" updateae_cmnt_date">
                                      Treated On: {moment(i.createdAt).format("DD/MM/YYYY HH:mm:ss")}
                                    </p>
                                  </div>
                                  : "")
                            })
                          }
                        </div>
                      </div>
                    }
                    <div>
                      {selectedDocument && !['xlsx', 'xls'].includes(extensions) && (
                        <Modal show={selectedDocument !== null} onHide={handleCloseModal} size="lg">
                          <Modal.Header closeButton>
                            <Modal.Title>Preview</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            {isImage(extensions) ? (
                              <img
                                src={selectedDocument.document_url}
                                title="Preview"
                                width="100%"
                                height="500px"
                                style={{ border: '1px solid #ccc', width: "100%" }}
                              />
                            ) : (
                              <iframe
                                src={selectedDocument.document_url}
                                title="Preview"
                                width="100%"
                                height="500px"
                                style={{ border: '1px solid #ccc' }}
                              />
                            )}
                          </Modal.Body>
                        </Modal>
                      )}
                    </div>

                    

                    <MeddraDetails
                    noRecordsFlag={noRecordsFlag}
                    dotsFlag={dotsFlag}
                    loadFlag={loadFlag}
                    listFlag={listFlag}
                      meddraDetails={meddraDetails}
                      handleMeddraClassification1={handleMeddraClassification1}
                      encodeMeddrabtn={encodeMeddrabtn}
                      value={value}
                      inputValue={inputValue}
                      handleCheckboxChange2={handleCheckboxChange2}
                      reviewedDtls={reviewedDtls}
                      medView={medView}
                      meddraClassification={meddraClassification}
                      onEncode2={onEncode2}
                      suggestions={suggestions}
                      handleDeleteMeddra={handleDeleteMeddra}
                      onSearch={onSearch} />





                  <MedicationDetails 
                  encodeBtn = {encodeBtn}
                  masterArray = {masterArray}
                  handleWhoddFunction={handleWhoDDClassification}
                  medicationDetails={medicationDetails}
                  whoddList={whoddList}
                  listFlag1={listFlag1}
                  dotsFlag1={dotsFlag1}
                  loadFlag1={loadFlag1}
                  suggestionsWhodd = {suggestionsWhodd}
                  handleDeleteFieldsWhoDD={handleDeleteFieldsWhoDD}
                  reviewedDtls={reviewedDtls}
                  onEncode1={onEncode1}
                  value1={value1}
                  onSearch1={onSearch1}
                  whoddClassificationMasterId={whoddClassificationMasterId}
                  handleCheckboxChange={handleCheckboxChange}
                  handleWHODD={handleWHODD}
                  whoDDClassification={whoDDClassification}
                  handleDelete={handleDelete}
                  noRecordsFlag1={noRecordsFlag1}
                  />





                    {!reviewedDtls && <div className="addBtn">
                      <button
                        className="white_btn px-2"
                        onClick={handleAddFields}
                        disabled={!isBtn}
                      >
                        Add More
                      </button>
                    </div>}

                    <div className={JustBtwn}>
                      {subjData.status !== EVENT_STATUS_REVIEWED && <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          alignItems: "start",
                        }}
                      >
                        <label htmlFor="add your comments" className="fw-bold fs-6">
                          Add your comments<span className="text-danger">*</span>
                        </label>
                        <textarea
                          id="add_your_comments"
                          style={{
                            width: "100%",
                            minHeight: "100px",
                            borderColor: "#E1E5E7",
                            borderRadius: "8px",
                            padding: "10px"
                          }}
                          placeholder="type here"
                          onChange={handleReviewerComments}
                        />
                      </div>}
                    </div>
                  </Col>
                </div>

                <div className="registrationStepsFooter" >
                  {subjData.status === EVENT_STATUS_REVIEWED ?
                    <button id="reviewedBackBtn" className="white_btn white_btn_back px-3" onClick={handleReviewBtns }>
                      Back
                    </button>
                    : <div className="d-flex gap-2">
                      <button className="white_btn white_btn_back px-3" id={'cancel'} onClick={handleReviewBtns}>
                        Back
                      </button>
                      <button
                        id={'sendBack'}
                        className="red_btn"
                        onClick={handleReviewBtns}
                        disabled={reviewerComment === ''}
                      >
                        Send Back for Correction
                      </button>

                      <button
                        id={'closereview'}
                        className="green_btn"
                        onClick={handleReviewBtns}
                        // disabled={!(closeReviewBtn && cmtbtnStat && closereviewWhodd)}
                        disabled={!(cmtbtnStat && medraSelected)}

                      >
                        Close Review
                      </button>
                    </div>}
                </div>
              </Row>
            </Container>
          )}
        </div>


        <PopUpAlert
          handleClose={handleClosePopup}
          open={open}
          // title={"?"}
          msg={alertMessage}
          close={"Cancel"}
          actionbtn={'Sure'}
          onConfirm={handleReviewActions}
        />
       
     


    </div>
     {loading && <Loader />}
     
    </>

  );
};

export default QRSubjectsList;

export const MeddraDetails = ({handleDeleteMeddra, noRecordsFlag, dotsFlag, loadFlag, meddraDetails, handleMeddraClassification1, encodeMeddrabtn, value, inputValue, handleCheckboxChange2, reviewedDtls, medView, meddraClassification, onEncode2, listFlag, suggestions, onSearch }) => {

  return (
    <div>
      {((!reviewedDtls) || (reviewedDtls && meddraClassification?.meddra_llt_master_id !== null)) && meddraDetails?.map((input, index) => {
        
        return (
          
          <div className="card review_card_bg p-3" key={index}>
            <div className="row justify-content-center " >
              <div className="col-4">
                <label htmlFor="lastName" className="custm_label_fw">
                  MedDRA Classification
                </label>
              </div>
              <div className="col">
                <div
                  style={{ display: "flex", alignItems: "center" }}
                  className="buttonIn"
                >
                  <input
                    type="text"
                    disabled={reviewedDtls}
                    name="medracode"
                    className="form-control mb-2"
                    id="text"
                    value={input.searchTerm}
                    onChange={(e) => handleMeddraClassification1(e, input.current_idx)}
                    placeholder={reviewedDtls ? meddraClassification?.llt_name : "Enter LLT Name"}
                    style={{ flex: "1", right: "4px", paddingRight: "80px" }}
                  />
                  <button disabled={encodeMeddrabtn} onClick={() => onEncode2(value, input)} className="medra_button" id="clear">
                    Search
                  </button>
                </div>
                <div className="dropdown drop_medra card mb-3 border-0 ">
                  <div className="" style={{ height: listFlag && "180px", overflow: "auto", position: "relative" }}>

                    <ThreeDots
                      height="40"
                      width="40"
                      radius="9"
                      color="lightgray"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{ left: "50%", position: "absolute", top: "0px" }}
                      wrapperClassName="position-absolute"
                      visible={dotsFlag}
                    />
                    {noRecordsFlag && <div className="d-flex justify-content-center m-auto align-items-center h-100">No records found</div>}
                    {input.medDRAEncode === false &&
                      (suggestions != null ? suggestions
                        .filter((item) => {
                          const searchTerm = value?.toLowerCase();
                          const fullName = item.llt_name?.toLowerCase();
                          return (
                            searchTerm &&
                            fullName.startsWith(searchTerm) &&
                            fullName !== searchTerm
                          );
                        })
                        .slice(0, 10)
                        .map((item) => {
                          return (
                            <div
                              onClick={() => onSearch(item.llt_name, input.current_idx)}
                              className="dropdown-row rounded px-2 py-1"
                              key={item.llt_name}
                            >
                              <div className="ps-2">{item.llt_name}</div>

                            </div>
                          )
                        }) : "")}
                    <ThreeDots
                      height="40"
                      width="40"
                      radius="9"
                      color="lightgray"
                      ariaLabel="three-dots-loading"
                      wrapperStyle={{ left: "50%", position: "absolute", top: "0px" }}
                      wrapperClassName="position-absolute"
                      visible={!suggestions}
                    />
                  </div>
                </div>
              </div>
              {medView && meddraClassification?.meddra_llt_master_id !== null &&
                <MeddraForm reviewedDtls={reviewedDtls} handleDeleteMeddra={handleDeleteMeddra} object={meddraClassification} inputValue={inputValue} />
              }
            </div>
            <div className="row">
              {<ThreeDots
                height="40"
                width="40"
                radius="9"
                color="lightgray"
                ariaLabel="three-dots-loading"
                wrapperStyle={{ left: "50%", position: "absolute", marginTop: "-20px" }}
                wrapperClassName="position-absolute"
                visible={loadFlag}
              />}
              <MeddraArray
                inputmeddraArray={input.meddraArray}
                inputcurrent_idx={input.current_idx}
                inputcheckedMeddra={input.checkedMeddra}
                handleCheckboxChange2={handleCheckboxChange2}
              />
            </div>          
            <div className="version_txt pb-2 px-3">Version 26.1</div>
          </div>
          
          )})
          }       
    </div>
  )
}

export const MedicationDetails = ({ handleWhoddFunction, masterArray, encodeBtn, medicationDetails, loadFlag1, whoddList, dotsFlag1, listFlag1, noRecordsFlag1, handleDeleteFieldsWhoDD, reviewedDtls, handleWhoDDClassification, onEncode1, value1, onSearch1, whoddClassificationMasterId, handleCheckboxChange, handleWHODD, whoDDClassification, handleDelete, suggestionsWhodd }) => {
  return (
    <div className="d-flex flex-column gap-3">
      {medicationDetails?.map((input, index) => {
        return (
          <>
            {((reviewedDtls && whoDDClassification?.length > 0) || (!reviewedDtls)) && (<div>
              <div className="card review_card_bg pt-3" key={index}>

                {index !== 0 && (
                  <div>
                    {(window.location.pathname !== '/pmsadminlistofsubjects' || window.location.pathname !== '/pmssubjectsreview') &&
                      <button
                        onClick={() => handleDeleteFieldsWhoDD(input.current_idx)}
                        className="cross_btn"
                      >
                        <span>x</span>
                      </button>
                    }
                  </div>
                )}
                <WhoddSearchBlock
                typeId ={ WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS}
                  whoDDClassification={whoDDClassification}
                  input={input}
                  reviewedDtls={reviewedDtls}
                  handleWhoddFunction={handleWhoddFunction}
                  encodeBtn={encodeBtn}
                  onEncode1={onEncode1}
                  value1={value1}
                  listFlag1={listFlag1}
                  dotsFlag1={dotsFlag1}
                  noRecordsFlag1={noRecordsFlag1}
                  suggestionsWhodd={suggestionsWhodd}
                  loadFlag1={loadFlag1}
                  masterArray={masterArray}
                  handleCheckboxChange={handleCheckboxChange}
                  handleDelete={handleDelete}
                  onSearch1={onSearch1}
                />

              </div>
            </div>)
            }
          </>
        )
      })}
    </div>
  )
}

export const MeddraArray =({handleCheckboxChange2, inputmeddraArray, inputcheckedMeddra, inputcurrent_idx})=>{
  return(
    <div className={`${window.location.pathname==='/pmsnewstudysetup'?"px-0":"px-1"}`}>
                {inputmeddraArray && inputmeddraArray?.map((inputValue, index) => {
                  const moreThanone = inputmeddraArray.length > 1
                  return (
                    <div key={index} className="d-flex position-relative out_orange_radiobtn justify-content-end">

                      <div className="card mb-4 review_inner_card_bg" style={{width:"95%"}}>
                    
                        <div className="card-body">
                      <input
                        type="radio"
                        className="custm_out_radiobtn"
                        checked={moreThanone ? inputValue.meddra_mdhier_master_id == inputcheckedMeddra : inputValue.meddra_mdhier_master_id}
                        id={inputValue.meddra_mdhier_master_id}
                        onChange={(e) => handleCheckboxChange2(inputValue, inputcurrent_idx)}

                      />
                          <form className={'gap-2 d-flex flex-column'}>
                          <InputFieldForClassifications title={"LLT"} causeName={inputValue.llt_name} causeCode={inputValue.llt_code}/>
                          <InputFieldForClassifications title={"PT"} causeName={inputValue.pt_name} causeCode={inputValue.pt_code}/>
                          <InputFieldForClassifications title={"HLT"} causeName={inputValue.hlt_name} causeCode={inputValue.hlt_code}/>
                          <InputFieldForClassifications title={"HLGT"} causeName={inputValue.hlgt_name} causeCode={inputValue.hlgt_code}/>
                          <InputFieldForClassifications title={"SOC"} socflag={inputValue.primary_soc_fg} causeName={inputValue.soc_name} causeCode={inputValue.soc_code}/>
                             
                          </form>
                        </div>
                      </div>
                    </div>
                  )
                })}
                {/* {window.location.pathname!=='/qrsubjectreview'&& inputmeddraArray.length>0 && <div className="version_txt pb-2">Version 26.1</div>} */}
              </div>
  )
}


export const MeddraForm = ({handleDeleteMeddra, object, inputValue,reviewedDtls,revSubjDtls}) => {
  return (
    <div >
      {object && <div className="card mb-4 review_inner_card_bg " >
        <div className={`${(window.location.pathname !== '/pmsadverseeventbank') ? "card-body px-0" : "card-body"}`}>
        {!reviewedDtls && !revSubjDtls && (
          <div>
             {(window.location.pathname !== "/pmsadminlistofsubjects"
                      && window.location.pathname !== '/pmssubjectsreview') ?
              <button onClick={handleDeleteMeddra} className="cross_btn">
                <span>x</span>
              </button>
              :null}
              </div>
            )}
            
          <form className="d-flex gap-1 flex-column">

            <InputFieldForClassifications title={"LLT"} causeName={object.llt_name} causeCode={object.llt_code} />
            <InputFieldForClassifications title={"PT"} causeName={object.pt_name} causeCode={object.pt_code} />
            <InputFieldForClassifications title={"HLT"} causeName={object.hlt_name} causeCode={object.hlt_code} />
            <InputFieldForClassifications title={"HLGT"} causeName={object.hlgt_name} causeCode={object.hlgt_code} />
            <InputFieldForClassifications title={"SOC"} socflag={object.primary_soc_fg} causeName={object.soc_name} causeCode={object.soc_code} />

          </form>
        </div>
      </div>}
    </div>
  )
}

export const InputFieldForClassifications = ({socflag, title, causeName, causeCode})=>{
  return(
    <div className="form-group row gap-2">
      <label className={`${title==='HLGT'|| title==='SOC' || title==='LLT' ? 'px-0':''} col-1 text-center col-form-label review_inner_card_text`}>
        {title&& title}
      </label>
    {causeName&&  <div className="col px-0">
        <input
          type="text"
          value={causeName}
          data-tooltip-content={causeName}
          data-tooltip-id={causeName}
          name="Genric Name"
          disabled
          className={`form-control ${socflag =="Y"?'text-success cstm_FW':""}`}
          id="text"
          // placeholder="LLT"
        />
        <Tooltip id={causeName} style={{ marginTop: "10px" }} />
      </div>}
    {causeCode&&  <div className="col-3">
        <input
          type="text"
          value={causeCode}
          data-tooltip-content={causeCode}
          data-tooltip-id={causeCode}
          name="Genric Name"
          disabled
          className={`form-control ${socflag =="Y"?'text-success cstm_FW':""}`}
          id="text"
          placeholder="LLT"
        />
      </div>}
    </div>
  )
}


export const WhoDDForm = ({ value }) => {
  return (
    <form>
      <div className="row d-flex mb-2" >
        <div className="col">
          <label className="">
            Drug Name
          </label>
          <div className=" ">
            <p>{value?.drug_name}</p>
          </div>
        </div>
        <div className="col pe-0">
          <label className="">
            Country Name
          </label>
          <div className=" ">
          <p className="indianFlag">
  {value?.country_name === "India" ? (
    <>
      <img src="./images/icons/indian_flag.png" alt="" width={20} height={15}/> {value?.country_name}
    </>
  ) : (
    value?.country_name
  )}
</p>

          </div>
        </div>
        <div className="col-2 pe-0 ps-0">
          <label
            htmlFor="llt"
            className=""
          >
            ATC Code
          </label>
          <div className="">
            <p>{value?.atc_code ? value?.atc_code : "-"}</p>
          </div>
        </div>
      </div>

      <div className="row d-flex mb-2" >
        <div className="col">
          <label
            htmlFor="llt"
            className=""
          >
            Manufacturer
          </label>
          <div className="">
            <p>{value?.mah}</p>
          </div>
        </div>
        <div className="col pe-0">
          <label
            htmlFor="llt"
            className=""
          >
            Pharm Form
          </label>
          <div className="">
            <p>{value?.pharmform_text ? value?.pharmform_text : "-"}</p>
          </div>
        </div>
        <div className="col-2 pe-0 ps-0">
          <label
            htmlFor="llt"
            className=""
          >
            Med-Prod ID
          </label>
          <div className="">
            <p>{value?.medicinalprod_id}</p>
          </div>
        </div>
      </div>

      <div className="d-flex row gap-3 justify-content-between whodd-sm-cards-text">
        {value?.substances?.map((sub, index )=> {
          return (
            <div key={index} className="card col px-0 " style={{ minWidth: "180px" }} >
              <div className="card-body py-2">
                <div className="" >
                  <div className="">
                    <label
                      htmlFor="llt"
                      className=""
                    >
                      Substance Name
                    </label>
                    <div className="">
                      <p>{sub?.substance_name}</p>
                    </div>
                  </div>

                  <div className="row">
                    <div className={`${(value?.substances?.length ===1) ? "col-5 me-3" :"col"} ps-0 `}>
                      <label
                        htmlFor="llt"
                        className=""
                      >
                        Quantity
                      </label>
                      <div className="">
                        <p>{sub.quantity}</p>
                      </div>
                    </div>
                    <div className="col ps-0">
                      <label
                        htmlFor="llt"
                        className=""
                      >
                        Unit
                      </label>
                      <div className="">
                        <p>{sub?.unit_text}</p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <p class="card-text">With supporting text below as a natural lead-in to additional content.</p> */}
              </div>
            </div>
          )
        })}
      </div>

    </form>
  )
}


 

export const WhoddSearchBlock = ({
  whoDDClassification, input, reviewedDtls, handleWhoddFunction, masterObjectArray, medicationId,
  encodeBtn, onEncode1, value1, listFlag1, dotsFlag1, noRecordsFlag1,
  suggestionsWhodd, loadFlag1, masterArray, handleCheckboxChange,
  handleDelete, onSearch1, typeId
}) => {
  const addScrollTop=()=>{
    const container = document.getElementById('search_container');

    // Scroll the container to the top
    if (container) {
      container.scrollTop = 0;
    }
  }
  return (
    <div className="row MR_event_review_list_WHODD pt-0" key={input.id}>

      <div className="col-4" style={{ textAlign: "center", display: "flex", flexDirection: "column" }}>
        <label htmlFor="lastName" className="custm_label_fw whodd_label_mr_event_review">
          WHODD Classification
        </label>
        <span style={{ fontSize: "12px", color: "gray" }} className="MR_event_review_list_WHODD_pattern">{reviewedDtls ? "" : "Enter minimum of 3 characters"}</span>
      </div>
      <div className="col">
        <div
          style={{ display: "flex", alignItems: "center" }}
          className="buttonIn"
        >
          <input
            type="text"
            disabled={reviewedDtls}
            name="medracode"
            className="form-control mb-2"
            id="text"
            value={input.searchTerm}
            onChange={(e) => handleWhoddFunction(e, input.current_idx)}
            placeholder={reviewedDtls ? "" : "Enter Drug Name"}
            style={{ flex: "1", right: "4px", paddingRight: "80px" }}
          />
          <button disabled={encodeBtn} onClick={() =>  {onEncode1(value1, input);addScrollTop()}} className="medra_button" id="clear">
            Search
          </button>
        </div>

        <div className={`dropdown drop_medra card ${listFlag1? "mb-3":"mb-1"} border-0 `}>
          <div className="" style={{ height: (listFlag1 && !input.whoDDEncode) && "180px", overflow: "auto", position: "relative", justifyContent: "center", alignItems: "center" }}>
            <ThreeDots
              height="40"
              width="40"
              radius="9"
              color="black"
              ariaLabel="three-dots-loading"
              wrapperStyle={{ left: "45%", position: "absolute", top: "26%" }}
              wrapperClassName="position-absolute"
              visible={dotsFlag1}
            />

            {listFlag1 && input.whoDDEncode === false && dotsFlag1 ?
              <div style={{ display: "flex", height: (listFlag1 && !input.whoDDEncode) && "180px", justifyContent: "center", alignItems: "center" }}>
                <span>Please Wait</span>
              </div>
              :
              null}
            {(noRecordsFlag1) && <div className="d-flex justify-content-center m-auto align-items-center h-100">No records found</div>}
            {input.whoDDEncode === false && (suggestionsWhodd?.filter((item) => {
              const searchTerm = value1.toLowerCase();
              const fullName = item.toLowerCase();
              return (
                searchTerm &&
                fullName.startsWith(searchTerm)
              );
            })
              .slice(0,)
              .map((item) => (
                <div
                  onClick={() => onSearch1(item, input.current_idx)}
                  className="dropdown-row ms-3 mb-1 me-2 rounded px-2 py-1"
                  key={item}
                  style={{ wordBreak: 'break-all' }}
                >
                  {item}
                </div>
              )))}
          </div>
        </div>
      </div>

      <div className={`${window.location.pathname==='/qrsubjectreview' ? "whodd_class_styls" :""}`} id="search_container">
        <div>
          {
            loadFlag1 ?
              <div style={{ display: "flex", height: "180px", justifyContent: "center", alignItems: "center" }}>
                <ThreeDots
                  height="40"
                  width="40"
                  radius="9"
                  color="black"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{ left: "47%", position: "absolute", marginTop: "-40px" }}
                  wrapperClassName="position-absolute"
                  visible={loadFlag1}
                />
                <span>Please Wait</span>
              </div> :
              null
          }
          {input.whoddArray?.map((element, index) => {
            const moreThanone = input.whoddArray.length > 1
            return (
              <div key={index} className="position-relative out_orange_radiobtn" style={{ marginLeft: "30px" }}>
                <input
                  type="radio"
                  className="custm_out_radiobtn"
                  checked={(moreThanone && typeId === WHODD_CONCOMITANT_MEDICATION) ? (masterObjectArray?.some(item => item?.whodd_id === element?.whodd_id && item?.medication_id === medicationId)) :
                    (moreThanone && typeId === WHODD_ANY_MEDICATION_USED_IN_LAST_3WEEKS) ? (masterArray?.some(item => item?.whodd_id === element?.whodd_id && item?.medication_id === medicationId))
                      : element.whodd_id}
                  id={element.whodd_id}
                  onChange={(e) => handleCheckboxChange(e, element, input.current_idx)}
                  style={{ width: "18px" }}
                />

                <div key={index} className="card mb-4 review_inner_card_bg_white_whodd ">
                  <div className="card-body ">
                    <WhoDDForm value={element} />
                  </div>
                </div>
                {/* {window.location.pathname!=='/qrsubjectreview' && <div className="version_txt pb-2">Version GLOBALC3Sep23</div>} */}
              </div>
            )
          })}
          { input.whoddArray?.map((ele, index) => index ===0) && whoDDClassification && whoDDClassification?.map((element, index) => {
            return (
              <div key={index} className="card mb-4 review_inner_card_bg_white_whodd" style={{ marginLeft: "10px" }}>
                <div className="card-body" >
                  {!reviewedDtls && <button
                    onClick={() => handleDelete(element.whodd_id)}
                    className="cross_btn"
                  >
                    <span>x</span>
                  </button>}

                  <WhoDDForm value={element} />
                </div>

              </div>

            )
          })}
          {window.location.pathname !== '/qrsubjectreview' && <div className="version_txt pb-2">Version GLOBALC3Sep23</div>}

        </div>

      </div>
    </div>
  )
}